import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=1c4fe258&scoped=true"
import script from "./top-notice.vue?vue&type=script&lang=js"
export * from "./top-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fe258",
  null
  
)

export default component.exports